<template>
    <v-dialog
        :value="isOpen"
        scrollable
        :max-width="canUpdateCalculationTraderMarginMinimalValue ? '600px' : '400px'"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @keydown.enter="onSave"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Narzut handlowca
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col v-if="canUpdateCalculationTraderMarginMinimalValue" cols="12" sm="6">
                        <v-text-field
                            v-mask="'####'"
                            :value="calculationTraderMargin.minimalValue"
                            label="Minimalny narzut"
                            suffix="%"
                            outlined
                            dense
                            :disabled="actionLoading"
                            :error-messages="calculationTraderMarginMinimalValueErrors"
                            @change="changeCalculationTraderMarginMinimalValue"
                        />
                    </v-col>
                    <v-col cols="12" :sm="canUpdateCalculationTraderMarginMinimalValue ? 6 : 12">
                        <v-text-field
                            v-model.number="calculationTraderMargin.value"
                            v-mask="'####'"
                            label="Narzut"
                            suffix="%"
                            outlined
                            dense
                            :disabled="actionLoading"
                            :error-messages="calculationTraderMarginValueErrors"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { hasUserPermission } from '@/utils/permissionsHandler'
import parse from '@/mixins/parse'

import { mask } from 'vue-the-mask'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    name: 'CalculationTraderMarginDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        calculationTraderMarginData: {
            type: Object,
            default: () => {}
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            calculationTraderMargin: {
                minimalValue: null,
                value: null
            }
        }
    },
    validations() {
        const rules = {
            calculationTraderMargin: {
                minimalValue: {
                    required,
                    minValue: minValue(0)
                },
                value: {
                    required,
                    minValue: minValue(this.calculationTraderMargin.minimalValue)
                }
            }
        }

        return rules
    },
    computed: {
        canUpdateCalculationTraderMarginMinimalValue() {
            return hasUserPermission('finances_update')
        },
        calculationTraderMarginMinimalValueErrors() {
            const errors = []

            if (!this.$v.calculationTraderMargin.minimalValue.$dirty) return errors

            if (!this.$v.calculationTraderMargin.minimalValue.required || !this.$v.calculationTraderMargin.minimalValue.minValue) {
                errors.push('Proszę podać prawidłową wartość.')
            }

            return errors
        },
        calculationTraderMarginValueErrors() {
            const errors = []

            if (!this.$v.calculationTraderMargin.value.$dirty) return errors

            !this.$v.calculationTraderMargin.value.required && errors.push('Proszę podać prawidłową wartość.')
            !this.$v.calculationTraderMargin.value.minValue && errors.push(`Minimalna marża wynosi ${this.calculationTraderMargin.minimalValue}%`)

            return errors
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.calculationTraderMargin = JSON.parse(JSON.stringify(this.calculationTraderMarginData))
            } else {
                setTimeout(() => {
                    this.calculationTraderMargin = {
                        minimalValue: null,
                        value: null
                    }
                    this.$v.$reset()
                }, 500)
            }
        }
    },
    methods: {
        changeCalculationTraderMarginMinimalValue(value) {
            this.calculationTraderMargin.minimalValue = Number(value)

            if (value > this.calculationTraderMargin.value) {
                this.calculationTraderMargin.value = Number(value)
            }
        },
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            const payload = {...this.calculationTraderMargin}

            if (!this.canUpdateCalculationTraderMarginMinimalValue) {
                delete payload['minimalValue']
            }

            this.$emit('on-save', payload)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>